<template>
  <div class="page ready">
    <div class="page-header">
      <span class="page-title">Austin Studio Tour</span>
    </div>

    <div class="intro-pages">
      <div class="intro-page page-info">
        <div class="intro-page-content">
          <p>Make the most of your tour experience with artist profiles, an interactive map, and saved favorites. </p>
          <img src="../assets/img/bm.svg" class="logo-bm" alt="">
          <button class="btn" @click="flickityNext">Next</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>
      </div>

      <div class="intro-page">
        <div class="intro-page-content">
          <h3>LEARN MORE ABOUT THE</h3>
          <div class="page-title">
            <img src="../assets/img/icon-artists.svg" class="page-icon" alt="" width="23">
            <h2>Participants</h2>
          </div>
          <p>Deep dive into all the participants with unique profiles for every artist including event info, artist bio, samples of their work and much more.</p>
          <button class="btn" @click="flickityNext">Next</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>

        <div class="screenshot">
          <img src="static/intro/profile.png" alt="">
        </div>
      </div>

      <div class="intro-page">
        <div class="intro-page-content">
          <h3>FILTER YOUR</h3>
          <div class="page-title">
            <img src="../assets/img/icon-artists.svg" class="page-icon" alt="" width="23">
            <h2>Participants</h2>
          </div>
          <p>Use the intuitive filtering feature to help you find what you are looking for. You can use this in the participant list and on our interactive map.</p>
          <button class="btn" @click="flickityNext">Next</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>

        <div class="screenshot">
          <img src="static/intro/filters.png" alt="">
        </div>
      </div>

      <div class="intro-page">
        <div class="intro-page-content">
          <h3>Explore AST with our</h3>
          <div class="page-title">
            <img src="../assets/img/icon-map.svg" class="page-icon" alt="" width="19">
            <h2>Interactive Map</h2>
          </div>
          <p>View all studios at once, or filter/search for a specific artist.</p>
          <button class="btn" @click="flickityNext">Next</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>

        <div class="screenshot">
          <img src="static/intro/map.png" alt="">
        </div>
      </div>

      <div class="intro-page">
        <div class="intro-page-content">
          <h3>ADD TO YOUR</h3>
          <div class="page-title">
            <img src="../assets/img/icon-fav-theme.svg" class="page-icon" alt="" width="24">
            <h2>Favorites</h2>
          </div>
          <p>Build yourself a custom tour by swiping left on any artist listing, or tap the ‘heart’ on the artists profile. </p>
          <button class="btn" @click="flickityNext">Next</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>

        <div class="screenshot">
          <img src="static/intro/favorite.png" alt="">
        </div>
      </div>

      <div class="intro-page">
        <div class="intro-page-content">
          <h3>DON&rsquo;T MISS A THING WITH OUR</h3>
          <div class="page-title">
            <img src="../assets/img/icon-events.svg" class="page-icon" alt="" width="24">
            <h2>Event Calendar</h2>
          </div>
          <p>All of this years events for your viewing pleasure. </p>
          <button class="btn" @click="introComplete">Get Started</button>
          <ul class="intro-dots">
            <li v-for="index in totalPages" :key="index" :class="{active: currentPage === (index - 1)}"></li>
          </ul>
        </div>

        <div class="screenshot">
          <img src="static/intro/events.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data() {
    return {
      currentPage: 0,
      totalPages: 6,
    };
  },
  mounted() {
    setTimeout(() => {
      this.flickityInit();
    }, 200);
  },
  methods: {
    flickityInit() {
      this.flickity = new Flickity(this.$el.querySelector(".intro-pages"), {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: "center",
        contain: true,
        adaptiveHeight: false
      });
      this.flickity.on("change", () => {
        this.currentPage = this.flickity.selectedIndex;
      });
    },
    flickityNext() {
      this.flickity.next();
    },
    introComplete() {
      this.$router.push("/");
      localStorage.setItem("hasSeenIntro", true);
      setTimeout(() => {
        if ('StatusBar' in window) StatusBar.styleLightContent();
      }, 300);
    }
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page {
  top: 0;
  height: 100vh;
  padding-top: 0;
  background-color: #E5E5E6;
  &.next-fadeScale-enter-to {
    animation: none;
  }
  .page-title {
    font-size: 24px;
  }
}

.intro-pages {
  &.loading {
    opacity: 0;
  }
}

.intro-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 60px 25px 0 25px;
  padding-top: calc(~'60px + env(safe-area-inset-top)');
  overflow: hidden;
  text-align: center;
  .intro-page-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h2 {
    font-size: 32px;
    font-weight: 700;
    color: @themeColor1;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
  }
  p {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 25px;
    @media (max-width: 400px) {
      font-size: 16px;
      line-height: normal;
    }
  }
  .page-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 25px 0;
    .page-icon {
      margin-right: 10px;
    }
  }
  .screenshot {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 0 30px;
    img {
      max-width: 100%;
    }
  }

  &.page-start {
    h1 {
      font-size: 65px;
      font-weight: 700;
      line-height: 65px;
    }
    h2 {
      margin: 50px 0 0 0;
      font-size: 30px;
      font-weight: bold;
      line-height: 35px;
      color: #000;
    }
    h3 {
      margin-bottom: 50px;
      font-size: 30px;
      font-weight: 400;
      line-height: 35px;
      text-transform: lowercase;
    }
    span {
      color: @themeColor1;
    }
  }
  &.page-info {
    padding-top: 80px;
    p {
      margin-bottom: 70px;
      font-size: 30px;
      font-weight: 300;
      line-height: 36px;
    }
    .logo-bm {
      width: 235px;
      height: 41px;
      margin-bottom: 70px;
    }
  }
}

.btn {
  display: block;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  font-size: 25px;
  font-weight: 500;
  border-radius: 24px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .19);
}
.intro-dots {
  margin: 20px 0 10px 0;
  text-align: center;
  li {
    display: inline-block;
    width: 9px;
    height: 9px;
    background-color: #0000;
    border: 1px solid @themeColor3;
    margin: 0 2px;
    border-radius: 50%;
    cursor: pointer;
    &.active {
      background-color: @themeColor3;
    }
  }
}

@media (max-height: 735px) {
  .intro-page {
    h3 {
      font-size: 16px;
    }
    h2 {
      font-size: 28px;
    }
  }
  .intro-page.page-info {
    p {
      font-size: 22px;
      line-height: 28px;
    }
    .logo-bm {
      width: 180px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Intro.vue